/* eslint-disable import/prefer-default-export */
export const useMain = {
  resultInfo: { // 结果页
    widthRatio: '80.6vw', // 内容宽度占比
    leftWidthRatio: '40.3%', // 左侧窗口宽度占比
    leftMinWidth: 510, // 左侧窗口最小宽度
    leftHeightRatio: '30vw', // 左侧高度占比
    stepsWidthRatio: '562px', // 步骤条宽度
    rightTemplateMinWidth: 580, // 右侧窗口最小宽度
  },
  outlineTag: [
    {
      type: '封面',
      typeVal: 'START',
    },
    {
      type: '目录',
      typeVal: 'CATALOG',
    },
    {
      type: '章节',
      typeVal: 'CHAPTER',
    },
    {
      type: '结束',
      typeVal: 'ENDING',
    },
  ],
  outlineInfo: { // 大纲配置
    titleMaxLimit: 100, // 标题最大字数限制
    contentMaxLimit: 300, // 内容最大字数限制
  },
}
